import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIdPath = returnPath("/admin/manufacturers/:id");
export const getIndexPath = returnPath("/admin/manufacturers");
